import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSubscriptionStatus } from "services/subscription";

export const loadSubscriptionAsync = createAsyncThunk(
  "subscription/load",
  getSubscriptionStatus
);
